import { render, staticRenderFns } from "./queryData.vue?vue&type=template&id=526b731b&scoped=true"
import script from "./queryData.vue?vue&type=script&lang=js"
export * from "./queryData.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "526b731b",
  null
  
)

export default component.exports